module.exports = __webpack_public_path__ + "img/poker-h10.1c75be06.svg";